import { ReactNode } from "react"

import { Box, Divider, Heading } from "@chakra-ui/react"

import ProtectedComponent from "components/PleaseLoginComp"
import DesktopSideMenu from "components/sidemenu/sidemenu"
import { MenuItem as MenuItemType } from "components/sidemenu/types"
import Tabs from "components/tabs/Tabs"
import useIsPermitted from "hooks/useIsPermittedHook/useIsPermitted"
import { HOST_TAB_LIST } from "layouts/host-properties-layout"

type HostDiscountLayoutProps = {
  children: ReactNode
  active?: string
}
export const DiscountSidebarMenuArr: MenuItemType[] = [
  {
    name: "Discounts",
    id: "discount",
    depth: 1,
    to: "/listings/discount/discounts",
    childMenu: [],
  },
  // {
  //   name: "Ready-made Discounts",
  //   depth: 1,
  //   id: "readyMadeDiscounts",
  //   to: "/listings/discount/ready-made-discounts",
  //   childMenu: [],
  // },
  {
    name: "Properties",
    depth: 1,
    id: "discountProperties",
    to: "/listings/discount/discount-properties",
    childMenu: [],
  },
  {
    name: "Admin Discount",
    depth: 1,
    id: "adminDiscount",
    to: "/listings/discount/admin-discounts",
    childMenu: [],
  },
]
const HostDiscountLayout = (props: HostDiscountLayoutProps) => {
  const { children, active } = props
  const hasAccessTo = useIsPermitted()
  const sidebarMenuArr = hasAccessTo?.isAdmin
    ? DiscountSidebarMenuArr
    : DiscountSidebarMenuArr.filter((item) => item.id !== "adminDiscount")

  return (
    <Box maxW='100%' px={{ base: "20px", lg: "30px", xl: "70px" }} minW='100%'>
      <Box py={{ base: "0", md: "16px" }} mx={{ base: "-20px", md: "0" }}>
        <Tabs tabsArr={HOST_TAB_LIST} />
      </Box>
      <Divider borderColor='#e1e1e1' />
      <Box mt={{ base: 4, md: 8 }} display='flex' gap={{ base: 7, xl: 10 }}>
        <Box
          w='210px'
          flexGrow={1}
          flexShrink={0}
          display={{ base: "none", lg2: "block" }}
        >
          <Heading size='sm'>Discounts</Heading>
          <DesktopSideMenu
            sidebarMenuArr={sidebarMenuArr.map(
              (x): MenuItemType => ({
                ...x,
                isActive: x.id === active,
              }),
            )}
          />
        </Box>
        <Box w='full'>
          <ProtectedComponent>{children}</ProtectedComponent>
        </Box>
      </Box>
    </Box>
  )
}

export default HostDiscountLayout
